export enum RootActions {
  GET_APPLICATION_CONFIG = 'GET_APPLICATION_CONFIG',
  GET_APPLICATION_STATS = 'GET_APPLICATION_STATS',
  UPDATE_APPLICATION_CONFIG = 'UPDATE_APPLICATION_CONFIG',
}

export enum RootGetters {
  APP_CONFIG = 'APP_CONFIG',
  APP_LOADING = 'APP_LOADING',
  APP_STATS = 'APP_STATS',
  ERROR_MESSAGES = 'ERROR_MESSAGES',
  LANGUAGE = 'LANGUAGE',
  LOCALE = 'LOCALE', // date-fns
}

export enum RootMutations {
  EMPTY_ERROR_MESSAGES = 'EMPTY_ERROR_MESSAGES',
  SET_ERROR_MESSAGES = 'SET_ERROR_MESSAGES',
  UPDATE_APPLICATION_CONFIG = 'UPDATE_APPLICATION_CONFIG',
  UPDATE_APPLICATION_LOADING = 'UPDATE_APPLICATION_LOADING',
  UPDATE_APPLICATION_STATS = 'UPDATE_APPLICATION_STATS',
  UPDATE_LANG = 'UPDATE_LANG',
}
